import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import type { Vinculo } from '../lib/api/types';
import { useAuth } from '../lib/auth/AuthContext';

/**
 * A entrada (A1) — e a escolha de vínculo, que é a parte que quase todo painel esquece.
 *
 * <p>Uma pessoa pode atender mais de uma empresa (ADR-039/ADR-046). Quando isso acontece o
 * servidor <b>não emite token</b>: ele devolve a lista e pede a escolha, porque o contexto
 * de banco tem uma empresa, uma só. Adivinhar a primeira aqui daria um painel que às vezes
 * abre na empresa errada — e o erro só apareceria quando alguém marcasse um item.
 */
export function LoginPage() {
  const { entrar } = useAuth();
  const navegar = useNavigate();

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [vinculos, setVinculos] = useState<Vinculo[] | null>(null);
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function tentar(membershipId?: string) {
    setErro(null);
    setEnviando(true);
    try {
      const pendentes = await entrar(email, senha, membershipId);
      if (pendentes) {
        setVinculos(pendentes);
        return;
      }
      navegar('/itens', { replace: true });
    } catch (e) {
      setErro(e instanceof Error ? e.message : 'Não foi possível entrar.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="login">
      <div className="caixa">
        <div className="wm">CONFIRA</div>
        <div className="sub">Painel da empresa</div>

        {vinculos ? (
          <>
            <div className="t-h3" style={{ marginBottom: 12 }}>
              Em qual empresa você está entrando?
            </div>
            <div className="escolha">
              {vinculos.map((v) => (
                <button key={v.membershipId} onClick={() => void tentar(v.membershipId)}>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 13.5 }}>{v.companyId}</div>
                    <div className="t-cap">{v.roles.length} papel(éis)</div>
                  </div>
                </button>
              ))}
            </div>
            <div className="t-cap" style={{ marginTop: 14 }}>
              Você entra em uma empresa por vez. Para trocar, saia e entre de novo.
            </div>
          </>
        ) : (
          <form
            className="form"
            onSubmit={(e) => {
              e.preventDefault();
              void tentar();
            }}
          >
            <div className="campo">
              <label htmlFor="email">E-mail</label>
              <input
                id="email"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="campo">
              <label htmlFor="senha">Senha</label>
              <input
                id="senha"
                type="password"
                autoComplete="current-password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
              />
            </div>
            {erro && <div className="aviso ruim">{erro}</div>}
            <button className="btn btn-primary" type="submit" disabled={enviando}>
              {enviando ? 'Entrando…' : 'Entrar'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
